import { TProcessMappingActions } from './process-mapping.actions';
import { TProcessMappingInfoActionType, TProcessMappingState } from './process-mapping.models';

export const initialState: TProcessMappingState = {
  processListingRes: null,
  processMapListingRes: null,
  processFactoryAssignListingRes: null,
};

export function processMappingReducer(state = initialState, action: TProcessMappingActions): TProcessMappingState {
  switch (action.type) {
    case TProcessMappingInfoActionType.FetchProcessListingSuccess:
      return { ...state, processListingRes: action.payload };

    case TProcessMappingInfoActionType.FetchProcessMapListingSuccess:
      return { ...state, processMapListingRes: action.payload };

    case TProcessMappingInfoActionType.FetchProcessFactoryAssignListingSuccess:
      return { ...state, processFactoryAssignListingRes: action.payload };

    default:
      return state;
  }
}
